import { createFileRoute, Link } from "@tanstack/react-router";
import { EmptyState } from "@/components/ui";
import { useApp } from "@/context/AppContext";
import { KundenTestimonials } from "@/pages/client/KundenTestimonials";

/**
 * „Eure Kundenstimmen" (14.09.2026): die Testimonial-Liste des Kunden —
 * Kunden und die Kunden-Vorschau sehen die Seite; das Team pflegt dieselbe
 * Liste in der Kundenkartei (Muster wie /kampagnen).
 */
export const Route = createFileRoute("/_angemeldet/kundenstimmen")({
	component: KundenstimmenSeite,
});

function KundenstimmenSeite() {
	const { role } = useApp();
	if (role !== "mitarbeiter") return <KundenTestimonials />;
	return (
		<div className="max-w-narrow mx-auto py-10">
			<EmptyState
				icon="users"
				title="Kundenstimmen pflegt das Team in der Kundenkartei"
				hint="Diese Seite ist die Kundensicht — Kontingent, Partner und Stand findest du in der Kundenkartei unter Kundenstimmen. Über das Auge in der Kundenliste siehst du die Kundensicht."
				action={
					<Link to="/kunden" className="btn-secondary">
						Zur Kundenliste
					</Link>
				}
			/>
		</div>
	);
}
